/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import controller from './controllers/controller';
import template from './views/student-list.html';
var module = angular.module('studentFilteration', [
    //import modules
]).controller('studentFilteration', controller);

module.constant('studentFilteration', {
})
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('studentFilteration', {
//             parent: 'app',
//             url: '/student-filteration',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'activityReportCardCtrl'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/educore_reports/inidividual/module.js